var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mainMsg || _vm.subMsg)?_c('div',{staticClass:"round-card"},[(_vm.mainMsg)?_c('div',{staticClass:"main-msg"},[_vm._v(_vm._s(_vm.mainMsg))]):_vm._e(),(_vm.subMsg)?_c('div',{staticClass:"sub-msg"},[_vm._v(_vm._s(_vm.subMsg))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }